"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_tv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "448eac83-aa2c-4eef-9ab4-8788205ff2ff",
    x1: 37,
    y1: 31,
    x2: 155,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "tv-hi"), /*#__PURE__*/React.createElement("g", {
    id: "3ab0ddee-7d13-4959-98f3-68df26509059",
    "data-name": "tv-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d2cc3bbc-8000-485f-a546-7f8b126e8b77",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "638918ae-8520-452d-aea7-2b43d23e9f8c",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08f1b4c3-05a0-4a99-ad82-e57be2c6ebf4",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ecf7cc87-a9c0-4363-951f-320814c2dac4",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "89e9fabc-ed9d-43b2-862d-ab76751f7d7e",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9dd7d6ee-49fe-497f-b636-969d631bde9a",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d5075dee-5d5f-4a31-b912-e0c08f41165f",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "31d9f576-fbdd-4b32-abbf-540611034037",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "51272614-feb5-4f59-ba76-f4d4a6782356",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d7297b21-5708-4ee2-9d64-637db32b3683",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8c6f87a6-0a57-477b-88c5-8e1b51d3b10d",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "60364c7b-afb4-4ca3-8a0c-9f8d7e06c55f",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cf0ed40a-a085-463c-8591-c90bb4b23904",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "18589a9e-1223-4dd1-ad21-73dbb550335e",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d820321c-be1e-4b0a-9ad2-233739eee14b",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "74d53787-69b1-4dd1-b64b-e50a5846daff",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3c9dec88-3430-4b27-82c0-395b3347c987",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "20eee661-d397-4f17-bac6-2fbcb9afffa9",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f2b64a6b-0beb-4098-97c4-4cad84d27e6e",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9829c29e-98e3-43f4-b84a-aba041a0d1a9",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c6ca0c77-63cb-46c0-af83-8c9f2ba6fff4",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b86fb449-fd51-4b2e-b247-16d65f390ad1",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3808cc93-b4cc-4380-af21-11ca123c4104",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "79d7ef62-aa56-4dd5-afe7-e40c273fcae5",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7873bf93-efad-4912-8c1c-beff26fac936",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6de96001-1c90-4f77-872c-e356401cdc73",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "b796cdf3-4ba5-48e3-8634-2e8634a7404b",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    transform: "translate(192 0) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 44,
    width: 160,
    height: 100,
    rx: 4,
    ry: 4,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,142H20a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4H172a4,4,0,0,0,4-4v-2A4,4,0,0,1,172,142Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 46,
    width: 156,
    height: 88,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 48,
    width: 152,
    height: 84,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 48,
    width: 152,
    height: 84,
    opacity: 0.5,
    fill: "url(#448eac83-aa2c-4eef-9ab4-8788205ff2ff)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.11,150h0A2,2,0,0,1,68,148h56.13a2,2,0,0,1,1.94,2h0",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.11,
    y: 144,
    width: 20,
    height: 4,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 138,
    r: 2,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "126.11 149.94 126.11 152 66.11 152 66.11 149.94",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.11,
    y: 150,
    width: 60,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 144,
    width: 20,
    height: 4,
    opacity: 0.06
  })))))))))))))))))))))))))))));
}

var _default = ic_tv;
exports.default = _default;